import { formatPrice } from "helpers";
import getCurrency from "helpers/currencyHelper";
import StatusComponent from "./installmetStstusComponent";

interface TableData {
  title: string;
  key: string;
  type?: string;
  description?: string;
  label?: string;
  pluralLabel?: string;
  pageTitle?: string;
  pageDescription?: string;
  disableDateFilter?: boolean;
  tableColumns: TableColumn[];
  actions: { [key: string]: any };
}
interface TableColumn {
  name: string;
  key: string;
  filterParams?: {
    column?: string;
    columnType?: string;
  };
  searchType?: string;
  dataKey?: { label?: string; value?: number; id?: number }[];
  reqUrl?: string;
  Component?: React.ReactElement | any;
}

const defaultColumn = [
  {
    name: "عنوان",
    key: "title",
  },
  {
    name: "تاریخ سر رسید",
    key: "dueDate",
    getValue: (item: any) => `${item?.type === "prepayment" ? "" : item.dueDate}`,
  },

  {
    name: "مبلغ قسط",
    key: "price",
    getValue: (item: any) =>
      `${formatPrice(item?.price || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
  },
  {
    name: "مانده",
    key: "remain",
    getValue: (item: any) =>
      `${formatPrice(item?.remain || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
  },
  {
    name: "پرداخت شده",
    key: "pay",
    getValue: (item: any) =>
      `${formatPrice(item?.pay || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
  },
  {
    name: "جریمه دیرکرد",
    key: "lateFees",
    getValue: (item: any) =>
      item?.type === "prepayment"
        ? ""
        : `${formatPrice(item?.lateFees || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
  },

  {
    name: "وضعیت",
    key: "status",
    Component: StatusComponent,
  },
];

export const installmentsShowTable: TableData[] = [
  {
    title: "نمایش تمامی اقساط",
    // description: "",
    key: "installmentShow",

    label: "دریافتی",
    pageTitle: "",
    pageDescription: "",
    pluralLabel: "",
    disableDateFilter: true,
    tableColumns: defaultColumn,
    actions: {},
  },
  {
    title: "اقساط پرداخت شده",
    // description: "",
    key: "completed",

    label: "اقساط پرداخت شده",
    pageTitle: "",
    pageDescription: "",
    pluralLabel: "",
    disableDateFilter: true,
    tableColumns: defaultColumn,
    actions: {},
  },
  {
    title: "اقساط پرداخت ناقص",
    // description: "",
    key: "ongoing",

    label: "اقساط پرداخت ناقص",
    pageTitle: "",
    pageDescription: "",
    pluralLabel: "",
    disableDateFilter: true,
    tableColumns: defaultColumn,
    actions: {},
  },
  {
    title: "اقساط سررسید نشده",
    // description: "",
    key: "notPassed",

    label: "اقساط سررسید نشده",
    pageTitle: "",
    pageDescription: "",
    pluralLabel: "",
    disableDateFilter: true,
    tableColumns: defaultColumn,
    actions: {},
  },
  {
    title: "اقساط پرداخت نشده",
    // description: "",
    key: "passed",

    label: "اقساط پرداخت شده",
    pageTitle: "",
    pageDescription: "",
    pluralLabel: "",
    disableDateFilter: true,
    tableColumns: defaultColumn,
    actions: {},
  },
];
